import React, { useState, useRef, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { DateTimePicker, TimePicker } from 'react-tempusdominus-bootstrap';
import 'tempusdominus-bootstrap/build/css/tempusdominus-bootstrap.min.css';
import { updateShopDataById, fetchZoomVideos } from '../../../services/apifp';
import ShopChat from '../ShopChat';
import * as AuthService from '../../../services/apifp';
import Stepper from 'react-stepper-horizontal';
import Card from 'react-bootstrap/Card';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import GoogleMapReact from 'google-map-react';
import Uploader from '../Uploader';
import SignatureCanvas from 'react-signature-canvas';
import moment from "moment";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import Spinner from 'react-bootstrap/Spinner';
import Table from 'react-bootstrap/Table';
import { SearchBox } from '../SearchBox'; // <-- added

// เพิ่มสไตล์สำหรับ autocomplete และตำแหน่ง search box
const autocompleteStyles = `
  .pac-container { z-index: 300000 !important; }
  #map-container .map-search-container {
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 300001;
    width: calc(100% - 20px);
    max-width: 600px;
    padding: 0 8px;
  }
  #map-container .map-search-container input {
    width: 100%;
    box-sizing: border-box;
  }
  @media (max-width: 576px) {
    #map-container .map-search-container {
      left: 5%;
      width: 100%;
      top: 8px;
    }
  }
`;

// ฟังก์ชันหลัก
const ModalItemshopAccountant = ({ shopId, item, dropdowns, loadData }) => {
  const user = useSelector((state) => state.auth.currentUser);
  const [editableItem, setEditableItem] = useState({});

  const [key, setKey] = useState('info')
  const [chat, setChat] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false); //
  const [loading, setLoading] = useState(false);
  const [approvePath, setApprovePath] = useState([]);
  const [formData, setFormData] = useState({ gpsLocation: '' });
  const [panel, setPanel] = useState({
    isMe: false,
    isCancelable: false,
    isEditable: false,
    isApprovable: false,
    isRejectable: false
  });

  const [loadingDocs, setLoadingDocs] = useState(true); // ✅ เพิ่ม useState ให้ loadingDocs
  const [showMap, setShowMap] = useState(false);
  const mapRef = useRef(null);
  const mapApi = useRef(null);
  const apiReady = useRef(false);
  const [mapInstance, setMapInstance] = useState(null); // <-- added
  const [mapsApiInstance, setMapsApiInstance] = useState(null); // <-- added
  const [zoomVideos, setZoomVideos] = useState([]);
  const [loadingZoom, setLoadingZoom] = useState(false);

  // อัปเดต State เมื่อ `item` หรือ `shopId` เปลี่ยน
  useEffect(() => {
    ////console.log("📌 ค่า item ที่รับมาใน ModalItemshopAccountant:", item);
    if (item) {
      // ({...s}) = (s)

      setEditableItem(item);
      if (item?.GPS) {
        const parts = item.GPS.split(",");
        if (parts.length === 2) {
          setMyposition({
            center: { lat: Number(parts[0]) || 13.545550016333902, lng: Number(parts[1]) || 100.96180662698616 },
            zoom: myposition.zoom,
          });
        }
      }
    }
  }, [item]);

  useEffect(() => {
    ////console.log('CHANGE');
    ////console.log(item);

    if (item) {
      fetchDocuments();
      // checkAdminStatus();
      //downloadCrWs();
      downloadChatWs(item?.SHOP_ID);
      //downloadPhotoWs(item?.shopid);
      downloadPathWs(item?.SHOP_ID);
    }
  }, [item]); // เปลี่ยนจาก props.item เป็น item

  useEffect(() => {
    // if (shopId) {
    //   loadZoomVideos(shopId);
    // }
  }, [shopId]);

  const loadZoomVideos = async (shopId) => {
    setLoadingZoom(true);
    try {
      const data = await fetchZoomVideos(shopId);
      ////console.log("🎥 วิดีโอที่โหลดจาก API:", data);
      setZoomVideos(data);
    } catch (error) {
      console.error(error.message);
    } finally {
      setLoadingZoom(false);
    }
  };

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    const formattedDate = date.toISOString().split("T")[0]; // YYYY-MM-DD
    const formattedTime = date.toTimeString().split(" ")[0].slice(0, 5); // HH:mm
    return `${formattedDate} ${formattedTime}`;
  };

  const [isFullscreen, setIsFullscreen] = useState(false);
  const mapContainerRef = useRef(null); // ✅ ใช้ useRef() แทน

  useEffect(() => {
    const checkFullscreen = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };
    document.addEventListener("fullscreenchange", checkFullscreen);
    return () => document.removeEventListener("fullscreenchange", checkFullscreen);
  }, []);


  const toggleFullscreen = () => {
    const mapContainer = document.getElementById("map-container");
    if (!document.fullscreenElement) {
      mapContainer?.requestFullscreen().catch((err) => console.error("Fullscreen error:", err));
    } else {
      document.exitFullscreen();
    }
  };

  const handleConfirmLocation = () => {
    if (!formData.gpsLocation) {
      toast.error('⚠️ กรุณาเลือกตำแหน่งบนแผนที่');
      return;
    }
    const [lat, lng] = formData.gpsLocation.split(',').map(Number);
    if (isNaN(lat) || isNaN(lng)) {
      toast.error('❌ ตำแหน่งไม่ถูกต้อง กรุณาลองใหม่');
      return;
    }
    // 🌐 อัปเดต editableItem.GPS และตำแหน่งแผนที่
    setEditableItem((prev) => ({
      ...prev,
      GPS: formData.gpsLocation,
    }));
    setMyposition({
      center: { lat, lng },
      zoom: 17, // ✅ ป้องกัน Zoom เปลี่ยนแบบผิดปกติ
    });
    toast.success(`📍 ตำแหน่งที่เลือก: ${lat.toFixed(6)}, ${lng.toFixed(6)}`);
    setShowMap(false);
  };

  function Marker({ lat, lng }) {
    return (
      <div
        style={{
          position: 'absolute',
          transform: 'translate(-50%, -50%)',
          color: 'red',
          fontSize: '24px',
        }}
      >
        <FontAwesomeIcon icon={fas.faMapMarkerAlt} /> {/* ไอคอน Marker */}
      </div>
    );
  }
  const [myposition, setMyposition] = useState({
    center: {
      lat: 13.545550016333902,
      lng: 100.96180662698616,
    },
    zoom: 17,
  });

  // Function to handle API loaded
  const handleApiLoaded = (map, maps) => {
    if (map && maps) {
      mapRef.current = map;
      mapApi.current = maps;
      setMapInstance(map); // <-- added
      setMapsApiInstance(maps); // <-- added
      apiReady.current = true;

      const mapOptions = {
        gestureHandling: 'greedy',
        zoom: 17,
        styles: [
          {
            featureType: 'all',
            elementType: 'all',
            stylers: [
              {
                visibility: 'on',
              },
            ],
          },
        ],
        mapTypeControl: true,
        mapTypeId: maps.MapTypeId.ROADMAP,
        mapTypeControlOptions: {
          style: maps.MapTypeControlStyle.HORIZONTAL_BAR,
          position: maps.ControlPosition.BOTTOM_CENTER,
          mapTypeIds: [maps.MapTypeId.ROADMAP, maps.MapTypeId.SATELLITE],
        },
      };

      map.setOptions(mapOptions); // Apply options to the map
    }
  };
  const downloadChatWs = async (shopid) => {
    try {
      const chats = await AuthService.downloadChat(shopid);
      if (chats.error) throw 'timeout';
      setChat(chats);
    } catch (error) {
      ////console.log('exit chat');
      //props.onHide();
      // dispatch(logoutUser());
      // navigate('/login');
      //window.location.href = '/login';
    }
  };

  const downloadPathWs = async (shopid) => {
    try {
      const path = await AuthService.downloadPath(shopid);
      ////console.log(path);
      if (path.error) throw 'timeout';
      setApprovePath(
        path.map((e, i) => {
          return {
            ...e,
            href: '#',
            onClick: (e) => {
              e.preventDefault();
            }
          };
        })
      );

      //ตั้งค่า panel
      setPanel((prevState) => ({
        ...prevState,
        isMe: item?.staffid === user.BY, // Edit
        isEditable: false,
        isCancelable:
          path.filter((e) => e.status === '').length == path.length - 1,
        isApprovable: path.find((e) => e.status === '')
          ? path.find((e) => e.status === '').members.includes(user.BY)
          : false,
        isRejectable: path.find((e) => e.status === '')
          ? path.find((e) => e.status === '').members.includes(user.BY)
          : false
      }));
    } catch (error) {
      ////console.log('exit path');
    }
  };
  // ฟังก์ชันจัดการการเปลี่ยนแปลงข้อมูลในฟิลด์
  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditableItem((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleUpdateShopData = async () => {
    try {
      const updatedData = {
        shopId: editableItem.SHOP_ID,
        name: editableItem.SHOP_TAX_NAME_TH || '',
        taxId: editableItem.ID_TAX || '',
        installationPoint: editableItem.SHOP_NAME_TH || '',
        contactPerson: editableItem.CONTACT_NAME_TH || '',
        phone: editableItem.MOBILE || '',
        email: editableItem.EMAIL || '',
        contactPerson2: editableItem.CONTACT_NAME_TH2 || '',
        addressByIdCard: editableItem.ADDRESS_TAX || "",
        address: editableItem.ADDRESS || '',
        gpsLocation: editableItem.GPS || '',
        rewardType: editableItem.CAL_TYPE || '',
        shopType: editableItem.SHOP_TYPE || '',
        installDate: editableItem.DATE_INSTALL || new Date().toISOString().split('T')[0],
        startDate: editableItem.DATE_START || new Date().toISOString().split('T')[0],
        endDate: editableItem.DATE_END ||
          new Date(new Date(editableItem.DATE_START || new Date()).setFullYear(new Date(editableItem.DATE_START || new Date()).getFullYear() + 1))
            .toISOString().split('T')[0],
        rentalFee: editableItem.RENTAL_FEE || '',
        machinesNumber: editableItem.MACHINES_NUMBER || '',
        msd: editableItem.MSD || '',
        bank: editableItem.BANK || '',
        bankAccount: editableItem.ACC_ID || '',
        signature: signature || '',
        signature2: signature2 || '',
        workDays: editableItem.WORK_DAYS || '',
        workHourStart: editableItem.WORK_HOUR_START ? editableItem.WORK_HOUR_START.substring(0, 5) : '',
        workHourEnd: editableItem.WORK_HOUR_END ? editableItem.WORK_HOUR_END.substring(0, 5) : '',
      };

      await updateShopDataById(updatedData);

      await loadData();
      toast.success("แก้ไขข้อมูลสำเสร็จ");
    } catch (error) {
      console.error("❌ Error updating shop:", error);
      toast.error("แก้ไขข้อมูลไม่สำเสร็จ");
    }
  };

  const updatePlanApproveWs = async (input) => {
    try {
      const result = await AuthService.updatePlanApprove(input);
      if (result.result === 'SUCCESS') toast.success('ปรับปรุงข้อมูลแล้ว');
      else toast.error('ปรับปรุงข้อมูลผิดพลาด');
      await props.onRefresh(input.shopid);
    } catch (error) { }
  };

  const onAgree = async () => {
    await updatePlanApproveWs({
      shopid: props.item.shopid,
      status: 'approve',
      system: props.item.system,
    });
    await props.onRefresh(props.item.shopid);
    props.onHide();
  };

  const uploadChatWs = async (shopid, message) => {
    try {
      const chats = await AuthService.uploadChat(shopid, message);
      if (chats.error) throw 'timeout';
      setChat(chats);
    } catch (error) {
      window.location.href = '/login';
    }
  };

  const onSendMessage = async (message) => {
    if (item) {
      await uploadChatWs(item?.SHOP_ID, message);
    }
  };

  const fetchDocuments = async () => {
    setLoadingDocs(true);
    try {
      if (!shopId) {
        console.warn("⚠️ ไม่มีค่า SHOP_ID -> ไม่โหลดเอกสาร");
        toast.warn("⚠️ ไม่มีค่า SHOP_ID ไม่สามารถโหลดเอกสารได้");
        setLoadingDocs(false);
        return;
      }

      const data = await AuthService.getDocument(shopId);

      if (!data || !Array.isArray(data)) {
        toast.warn("⚠️ ไม่มีเอกสารที่ต้องอัปโหลด");
        setDocuments([]);
      } else {
        setDocuments(data);
      }

    } catch (error) {
      console.error("❌ โหลดเอกสารล้มเหลว:", error);
      toast.error(`🚨 โหลดเอกสารล้มเหลว: ${error.message}`);
    } finally {
      setLoadingDocs(false);
    }
  };

  const handleUpdateDocument = (updatedDoc) => {
    setDocuments((prevDocs) =>
      prevDocs.map((doc) =>
        doc.DOC_TYPE_ID === updatedDoc.DOC_TYPE_ID
          ? { ...doc, DOC_PATH: updatedDoc.DOC_PATH, STATUS: updatedDoc.STATUS, REMARK: updatedDoc.REMARK }
          : doc
      )
    );
    toast.success("📂 อัปเดตเอกสารสำเร็จ!");
  };
  // เพิ่มตัวแปร documents
  const [documents, setDocuments] = useState([]);

  useEffect(() => {
    const checkAdminStatus = async () => {
      try {
        const result = await AuthService.checkAdmin();
        setIsAdmin(result.value);
      } catch (error) {
        console.error("🚨 ตรวจสอบสิทธิ์แอดมินล้มเหลว:", error);
        setIsAdmin(false);
      }
    };

    checkAdminStatus();
  }, []);

  // ✅ ฟังก์ชันส่งข้อมูลไปยัง API เพื่ออัปเดตสถานะ
  const handleUpdateStatus = async (status) => {
    if (!item?.SHOP_ID) {
      toast.error("⚠️ ไม่มีค่า SHOP_ID");
      return;
    }
    setLoading(true); // ✅ เริ่มโหลด
    try {
      const result = await AuthService.updateShopStatus(item.SHOP_ID, status);

      if (result.success) {
        toast.success(result.message);
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      toast.error("🚨 ไม่สามารถอัปเดตสถานะได้");
      console.error("🚨 API Error:", error);
    } finally {
      setLoading(false); // ✅ จบโหลดเสมอ ไม่ว่าจะสำเร็จหรือผิดพลาด
    }
    await loadData();
  };

  const [signature, setsignature] = useState(''); // เก็บ Base64 ลายเซ็น
  const [showSignatureModal, setShowSignatureModal] = useState(false);
  const handleShowSignatureModal = () => {
    setShowSignatureModal(true); // แสดง Modal
  };

  const handleCloseSignatureModal = () => setShowSignatureModal(false);
  const signRef = useRef(null); // 🔹 ใช้ useRef() แทน

  const handleGenerateSignature = () => {
    if (signRef.current) {
      const signatureDataUrl = signRef.current
        .getTrimmedCanvas()
        .toDataURL('image/png');
      setsignature(signatureDataUrl); // บันทึกเฉพาะลายเซ็น
      handleCloseSignatureModal(); // ปิด Modal
    }
  };

  const handleClearSignature = () => {
    if (signRef.current) {
      signRef.current.clear();
      setsignature('');
    }
  };

  const [signature2, setSignature2] = useState(''); // เก็บลายเซ็นคนที่สอง
  const [showSignature2Modal, setShowSignature2Modal] = useState(false); // แสดง/ซ่อน Modal

  // ฟังก์ชันเปิด Modal สำหรับลายเซ็นคนที่สอง
  const handleShowSignature2Modal = () => setShowSignature2Modal(true);
  const handleCloseSignature2Modal = () => setShowSignature2Modal(false);
  const signRef2 = useRef(null); // 🔹 ใช้ useRef() แทน
  // ฟังก์ชันจัดการการสร้างลายเซ็นคนที่สอง
  const handleGenerateSignature2 = () => {
    if (signRef2.current) {
      const signatureDataUrl = signRef2.current
        .getTrimmedCanvas()
        .toDataURL('image/png');
      setSignature2(signatureDataUrl); // เก็บลายเซ็นใน State
      handleCloseSignature2Modal(); // ปิด Modal
    }
  };

  // ฟังก์ชันเคลียร์ลายเซ็นคนที่สอง
  const handleClearSignature2 = () => {
    if (signRef2.current) {
      signRef2.current.clear();
      setSignature2(''); // รีเซ็ตลายเซ็น
    }
  };

  return (
    <div className="row">
      <style dangerouslySetInnerHTML={{ __html: autocompleteStyles }} /> {/* <-- added */}
      <Modal show={showSignatureModal} onHide={handleCloseSignatureModal} centered
        style={{ zIndex: 9999 }}
      >
        <Modal.Header closeButton>
          <Modal.Title>ลงนามผู้กระทำการแทน</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className="col-12"
            style={{
              border: "2px solid black",
              width: "100%",
              height: 200,
            }}
          >
            <SignatureCanvas
              canvasProps={{
                width: 500,
                height: 200,
                className: "sigCanvas",
              }}
              ref={signRef}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={handleGenerateSignature}>
            ใช้ลายเซ็นนี้
          </Button>
          <Button variant="warning" onClick={handleClearSignature}>
            เซ็นใหม่
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Modal ลายเซ็น */}
      <Modal show={showSignature2Modal} onHide={handleCloseSignature2Modal} centered
        style={{ zIndex: 9999 }}
      >
        <Modal.Header closeButton>
          <Modal.Title>ลงนามพยาน/ผู้ติดต่อประสานงาน</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className="col-12"
            style={{
              border: "2px solid black",
              width: "100%",
              height: 200,
            }}
          >
            <SignatureCanvas
              canvasProps={{
                width: 500,
                height: 200,
                className: "sigCanvas",
              }}
              ref={signRef2}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={handleGenerateSignature2}>
            ใช้ลายเซ็นนี้
          </Button>
          <Button variant="warning" onClick={handleClearSignature2}>
            เซ็นใหม่
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Modal สำหรับเลือกตำแหน่งแผนที่ */}
      <Modal show={showMap} onHide={() => setShowMap(false)} size="lg" centered
        style={{ zIndex: 9999 }}
      >
        <Modal.Header closeButton>
          <Modal.Title>เลือกตำแหน่งบนแผนที่</Modal.Title>
        </Modal.Header>

        <div className="map-search-container">
          <SearchBox
            map={mapInstance}
            mapApi={mapsApiInstance}
            addplace={(place) => {
              if (!place || !place.geometry) return;
              const lat = place.geometry.location.lat();
              const lng = place.geometry.location.lng();
              if (mapRef.current?.panTo) mapRef.current.panTo({ lat, lng });
              if (mapRef.current?.setZoom) mapRef.current.setZoom(17);
              setMyposition((prev) => ({ ...prev, center: { lat, lng }, zoom: 17 }));
              setFormData((prev) => ({ ...prev, gpsLocation: `${lat.toFixed(6)},${lng.toFixed(6)}` }));
            }}
          />
        </div>

        <Modal.Body>
          <div
            ref={mapContainerRef}
            id="map-container"
            style={{ height: isFullscreen ? "100vh" : "60vh", width: "100%", position: "relative" }}
          >
            <GoogleMapReact
              bootstrapURLKeys={{
                key: 'AIzaSyB88aLnfSb_Fe1_q8483R6_jcZjKznODWo', // ใช้ API Key
                libraries: ['places', 'geometry'], // โหลดไลบรารีที่จำเป็น
              }}
              center={myposition.center} // ตั้งค่า Center จาก myposition
              defaultZoom={myposition.zoom} // ใช้ค่า Zoom จาก myposition
              yesIWantToUseGoogleMapApiInternals
              onGoogleApiLoaded={({ map, maps }) => {
                handleApiLoaded(map, maps); // ฟังก์ชันจัดการ API ของ Google Maps
              }}
              onClick={({ lat, lng }) => {
                // อัปเดตตำแหน่ง Marker เมื่อผู้ใช้คลิกบนแผนที่
                setMyposition({
                  center: { lat, lng },
                  zoom: myposition.zoom,
                });

                // เพิ่มตำแหน่งที่เลือกไปยัง Marker
                setFormData((prevState) => ({
                  ...prevState,
                  gpsLocation: `${lat.toFixed(6)},${lng.toFixed(6)}`
                }));
              }}
            >
              {/* Component Marker */}
              <Marker lat={myposition.center.lat} lng={myposition.center.lng} />
            </GoogleMapReact>
            <button
              onClick={toggleFullscreen}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                background: "white",
                border: "1px solid #ccc",
                padding: "8px",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              {isFullscreen ? "ออกจาก Fullscreen" : "Fullscreen"}
            </button>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={handleConfirmLocation}
          >
            ยืนยันตำแหน่ง
          </Button>

          <Button variant="secondary" onClick={() => setShowMap(false)}>
            ปิด
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="col-12 col-md-9">
        <Card className="bg-light">
          <Stepper
            size={64}
            activeColor={'#f8f9fa'}
            completeColor={'#f8f9fa'}
            defaultColor={'#f8f9fa'}
            titleFontSize={12}
            circleFontSize={14}
            steps={approvePath}
            activeStep={
              approvePath.filter((e) => e.status === 'approve').length ===
                approvePath.length
                ? approvePath.length - 1
                : approvePath.filter((e) => e.status === 'approve').length
            }
          />
        </Card>
        <Tabs
          id="shop-details-tabs" className="mb-4"
          activeKey={key}
          onSelect={(k) => {
            setKey(k);
            if (k === "zoom")
              loadZoomVideos(shopId);
          }}>
          <Tab eventKey="info" title="ข้อมูลทั้งหมดร้านค้าของฉัน">
            <Form.Group className="mb-3 col-md-4">
              <Form.Label>SHOP ID</Form.Label>
              <Form.Control
                type="text"
                name="SHOP_ID"
                value={editableItem.SHOP_ID || 'N/A'}
                readOnly
              />
            </Form.Group>

            <div className="row">
              <Form.Group className="mb-3 col-md-4">
                <Form.Label>ชื่อนิติบุคคล/ชื่อบุคคล</Form.Label>
                <Form.Control
                  type="text"
                  name="SHOP_TAX_NAME_TH"
                  value={editableItem.SHOP_TAX_NAME_TH || ''}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group className="mb-3 col-md-4">
                <Form.Label>เลขผู้เสียภาษี/เลขบัตรประชาชน</Form.Label>
                <Form.Control
                  type="text"
                  name="ID_TAX"
                  value={editableItem.ID_TAX || ''}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) { // ตรวจสอบให้เป็นตัวเลขเท่านั้น
                      handleChange(e);
                    }
                  }}
                  pattern="\d*" // HTML pattern ให้พิมพ์ได้เฉพาะตัวเลข
                />
              </Form.Group>

              <Form.Group className="mb-3 col-md-4">
                <Form.Label>ชื่อจุดติดตั้ง/ชื่อร้านค้า</Form.Label>
                <Form.Control
                  type="text"
                  name="SHOP_NAME_TH"
                  value={editableItem.SHOP_NAME_TH || ''}
                  onChange={handleChange}
                />
              </Form.Group>
            </div>
            <div className="row">
              <Form.Group className="mb-3 col-md-4">
                <Form.Label>ผู้กระทำการแทน</Form.Label>
                <Form.Control
                  type="text"
                  name="CONTACT_NAME_TH"
                  value={editableItem.CONTACT_NAME_TH || ''}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group className="mb-3 col-md-4">
                <Form.Label>เบอร์โทรศัพท์</Form.Label>
                <Form.Control
                  type="text"
                  name="MOBILE"
                  value={editableItem.MOBILE || ''}
                  // onChange={handleChange}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) { // ตรวจสอบให้เป็นตัวเลขเท่านั้น
                      handleChange(e);
                    }
                  }}
                  pattern="\d*" // HTML pattern ให้พิมพ์ได้เฉพาะตัวเลข
                />
              </Form.Group>

              <Form.Group className="mb-3 col-md-4">
                <Form.Label>อีเมล์</Form.Label>
                <Form.Control
                  type="email"
                  name="EMAIL"
                  value={editableItem.EMAIL || ''}
                  onChange={handleChange}
                />
              </Form.Group>
            </div>
            <div className="row">
              <Form.Group className="mb-3 col-md-4">
                <Form.Label>ผู้ติดต่อประสานงาน(ชื่อและเบอร์โทร)</Form.Label>
                <Form.Control
                  type="text"
                  name="CONTACT_NAME_TH2"
                  value={editableItem.CONTACT_NAME_TH2 || ''}
                  onChange={handleChange}
                />
              </Form.Group>
              <Form.Group className="mb-3 col-md-4">
                <Form.Label>วันทำการ</Form.Label>
                <Form.Control
                  as="select"
                  name="WORK_DAYS"
                  value={editableItem.WORK_DAYS || ''}
                  onChange={handleChange}
                >
                  <option value="">-- เลือกวันทำการ --</option>
                  {dropdowns?.SHOP_WORKING_DAY?.DATA.map((workDays) => (
                    <option key={workDays.value} value={workDays.value}>
                      {workDays.label}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
              <Form.Group className="mb-3 col-md-2">
                <Form.Label>เวลาเปิดเครื่อง</Form.Label>
                <TimePicker
                  date={editableItem.WORK_HOUR_START ? moment(`1970-01-01T${editableItem.WORK_HOUR_START}`).format("HH:mm") : "00:00"}
                  format="HH:mm" // ✅ ใช้รูปแบบเวลา 24 ชั่วโมง
                  onChange={(e) => {
                    if (e && e.date) {
                      const selectedTime = e.date.format("HH:mm"); // ✅ ดึงเฉพาะเวลา
                      setEditableItem((prev) => ({
                        ...prev,
                        WORK_HOUR_START: selectedTime, // ✅ บันทึกเฉพาะเวลา (HH:mm)
                      }));
                    }
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-3 col-md-2">
                <Form.Label>เวลาปิดเครื่อง</Form.Label>
                <TimePicker
                  date={editableItem.WORK_HOUR_END ? moment(`1970-01-01T${editableItem.WORK_HOUR_END}`).format("HH:mm") : "00:00"}
                  format="HH:mm" // ✅ ใช้รูปแบบเวลา 24 ชั่วโมง
                  onChange={(e) => {
                    if (e && e.date) {
                      const selectedTime = e.date.format("HH:mm"); // ✅ ดึงเฉพาะเวลา
                      setEditableItem((prev) => ({
                        ...prev,
                        WORK_HOUR_END: selectedTime, // ✅ บันทึกเฉพาะเวลา (HH:mm)
                      }));
                    }
                  }}
                />
              </Form.Group>
            </div>
            <Form.Group className="mb-3">
              <Form.Label>ที่อยู่ตามบัตรประชาชน/ภ.พ.20</Form.Label>
              <Form.Control
                as="textarea"
                name="ADDRESS_TAX"
                value={editableItem.ADDRESS_TAX || ''}
                onChange={handleChange}
              />
            </Form.Group>
            <div className="row">
              <Form.Group className="mb-3 col-md-4">
                <Form.Label>GPS Location</Form.Label>
                <div className="input-group">
                  {/* Input Field */}
                  <Form.Control
                    type="text"
                    name="gpsLocation"
                    value={editableItem.GPS || ''}
                    readOnly
                  />
                  {/* Button with Icon */}
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={() => {
                      setShowMap(true);
                    }}
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                  >
                    <FontAwesomeIcon icon={fas.faLocationDot} />
                  </button>
                </div>
              </Form.Group>
              <Form.Group className="mb-3 col-md-4">
                <Form.Label>ชนิดผลตอบแทนจ่าย</Form.Label>
                <Form.Control
                  as="select"
                  name="CAL_TYPE"
                  value={editableItem.CAL_TYPE || ''}
                  onChange={handleChange}
                >
                  <option value="">-- เลือกชนิดผลตอบแทนจ่าย --</option>
                  {dropdowns?.PAYMENT?.DATA.map((payment) => (
                    <option key={payment.value} value={payment.value}>
                      {payment.label}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
              <Form.Group className="mb-3 col-md-4">
                <Form.Label>ชนิดร้านค้า</Form.Label>
                <Form.Control
                  as="select"
                  name="SHOP_TYPE"
                  value={editableItem.SHOP_TYPE || ''}
                  onChange={handleChange}
                >
                  <option value="">-- เลือกชนิดร้านค้า --</option>
                  {dropdowns?.SHOP_TYPE?.DATA.map((shopType) => (
                    <option key={shopType} value={shopType.value}>
                      {shopType.label}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </div>
            <Form.Group className="mb-3">
              <Form.Label>ที่อยู่จุดติดตั้ง</Form.Label>
              <Form.Control
                as="textarea"
                name="ADDRESS"
                value={editableItem.ADDRESS || ''}
                onChange={handleChange}
              />
            </Form.Group>
            <div className="row">
              <Form.Group className="mb-3 col-md-4">
                <Form.Label>ประมาณการวันที่ติดตั้ง</Form.Label>
                <DateTimePicker
                  date={editableItem.DATE_INSTALL ? new Date(editableItem.DATE_INSTALL) : new Date()}
                  format="YYYY-MM-DD"
                  onChange={(e) => {
                    if (e && e.date) {
                      const selectedDate = e.date.toISOString().split('T')[0];
                      setEditableItem((prev) => ({
                        ...prev,
                        DATE_INSTALL: selectedDate,
                      }));
                    }
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-3 col-md-4">
                <Form.Label>ค่าเช่า</Form.Label>
                <Form.Control
                  type="text"
                  name="RENTAL_FEE"
                  value={editableItem.RENTAL_FEE || ''}
                  // onChange={handleChange}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) { // ตรวจสอบให้เป็นตัวเลขเท่านั้น
                      handleChange(e);
                    }
                  }}
                  pattern="\d*" // HTML pattern ให้พิมพ์ได้เฉพาะตัวเลข
                />
              </Form.Group>
              <Form.Group className="mb-3 col-md-4">
                <Form.Label>MSD</Form.Label>
                <Form.Control
                  as="select"
                  name="MSD"
                  value={editableItem.MSD || ''}
                  onChange={handleChange}
                >
                  <option value="">-- เลือกชนิดร้านค้า --</option>
                  {dropdowns?.MSD?.DATA.map((msd) => (
                    <option key={msd} value={msd.value}>
                      {msd.label}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </div>
            <div className="row">
              <Form.Group className="mb-3 col-md-4">
                <Form.Label>จำนวนเครื่อง</Form.Label>
                <Form.Control
                  type="number"
                  name="MACHINES_NUMBER"
                  value={editableItem.MACHINES_NUMBER || ''}
                  // onChange={handleChange}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) { // ตรวจสอบให้เป็นตัวเลขเท่านั้น
                      handleChange(e);
                    }
                  }}
                  pattern="\d*" // HTML pattern ให้พิมพ์ได้เฉพาะตัวเลข
                />
              </Form.Group>
              {/* วันที่เริ่มต้นสัญญา */}
              <Form.Group className="mb-3 col-md-4">
                <Form.Label>วันที่เริ่มต้นสัญญา</Form.Label>
                <DateTimePicker
                  date={editableItem.DATE_START ? new Date(editableItem.DATE_START) : new Date()}
                  format="YYYY-MM-DD"
                  onChange={(e) => {
                    if (e?.date) {
                      const startDate = e.date.toISOString().split('T')[0];
                      const endDate = new Date(e.date);
                      endDate.setFullYear(endDate.getFullYear() + 1); // +1 ปี

                      setEditableItem((prev) => ({
                        ...prev,
                        DATE_START: startDate,
                        DATE_END: endDate.toISOString().split('T')[0], // ปรับ endDate อัตโนมัติ
                      }));
                    }
                  }}
                />
              </Form.Group>
              {/* วันที่สิ้นสุดสัญญา */}
              <Form.Group className="mb-3 col-md-4">
                <Form.Label>วันที่สิ้นสุดสัญญา</Form.Label>
                <DateTimePicker
                  date={
                    editableItem.DATE_END
                      ? new Date(editableItem.DATE_END)
                      : new Date(new Date().setFullYear(new Date().getFullYear() + 1))
                  }
                  format="YYYY-MM-DD"
                  onChange={(e) => {
                    if (e?.date) {
                      const endDate = e.date.toISOString().split('T')[0];
                      setEditableItem((prev) => ({
                        ...prev,
                        DATE_END: endDate,
                      }));
                    }
                  }}
                />
              </Form.Group>
            </div>
            <div className="row">
              <Form.Group className="mb-3 col-md-4">
                <Form.Label>ธนาคาร</Form.Label>
                <Form.Control
                  as="select"
                  name="BANK"
                  value={editableItem.BANK || ''}
                  onChange={handleChange}
                >
                  <option value="">-- เลือกชนิดร้านค้า --</option>
                  {dropdowns?.BANK?.DATA.map((bank) => (
                    <option key={bank} value={bank.value}>
                      {bank.label}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
              <Form.Group className="mb-3 col-md-4">
                <Form.Label>เลขที่บัญชีธนาคาร</Form.Label>
                <Form.Control
                  type="text"
                  name="ACC_ID"
                  value={editableItem.ACC_ID || ''}
                  // onChange={handleChange}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) { // ตรวจสอบให้เป็นตัวเลขเท่านั้น
                      handleChange(e);
                    }
                  }}
                  pattern="\d*" // HTML pattern ให้พิมพ์ได้เฉพาะตัวเลข
                />
              </Form.Group>
            </div>
            <div className="row p-0">
              {/* การรับรู้และลายเซ็น */}
              <div className="col-md-6 col-12 m-0">
                <Card className="m-0 col-md-12">
                  <Card.Header>ลงนามผู้กระทำการแทน</Card.Header>
                  <Card.Body>
                    <div id="signature-area" className="mt-3 position-relative" style={{ width: '100%', height: '150px', border: '1px solid gray', backgroundColor: 'white', position: 'relative', display: 'flex', alignItems: 'center' }}>
                      <button className="btn btn-secondary" type="button" onClick={handleShowSignatureModal} style={{ zIndex: 1 }}>
                        <i className="fa fa-pencil"></i> ลงนาม
                      </button>
                      {signature && <img src={signature} alt="ลายเซ็นผู้กระทำการแทน" style={{ maxWidth: '100%', maxHeight: '100%', display: signature ? 'block' : 'none' }} />}
                    </div>
                  </Card.Body>
                </Card>
              </div>
              <div className="col-md-6 col-12 m-0">
                {/* การรับรู้และลายเซ็น */}
                <Card className="m-0 col-md-12">
                  <Card.Header>ลงนามพยาน/ผู้ติดต่อประสานงาน</Card.Header>
                  <Card.Body>
                    <div id="signature-area" className="mt-3 position-relative" style={{ width: '100%', height: '150px', border: '1px solid gray', backgroundColor: 'white', position: 'relative', display: 'flex', alignItems: 'center' }}>
                      <button className="btn btn-secondary" type="button" onClick={handleShowSignature2Modal} style={{ zIndex: 1 }}>
                        <i className="fa fa-pencil"></i> ลงนาม
                      </button>
                      {signature2 && <img src={signature2} alt="ลายเซ็นพยาน" style={{ maxWidth: '100%', maxHeight: '100%', display: signature2 ? 'block' : 'none' }} />}
                    </div>
                  </Card.Body>
                </Card>
              </div>
            </div>
          </Tab>

          <Tab eventKey="documents" title="ไฟล์อัปโหลด" disabled={editableItem.STATUS === "RJ"}>
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-body">
                        {loadingDocs ? (
                          <p className="text-center text-muted">⏳ กำลังโหลดเอกสาร...</p>
                        ) : documents.length > 0 ? (
                          <form className="form-horizontal">
                            {documents.map((e, i) => (
                              <div className="form-group row" key={i}>
                                <label htmlFor={`doc-${i}`} className="col-sm-3 col-form-label">
                                  {e.DOC_TYPE_NAME}
                                </label>
                                <div className="col-sm-9">
                                  <Uploader
                                    key={`ul-${i}`}
                                    onUpdate={handleUpdateDocument}
                                    images={e.DOC_PATH ? [{ src: e.DOC_PATH }] : []}
                                    item={{
                                      ...e,
                                      SHOP_ID: shopId,
                                      TYPE: e.DOC_TYPE_ID,
                                      _claim_id: '',
                                      index: i,
                                      _type: 'PROFILE'
                                    }}
                                  />
                                </div>
                              </div>
                            ))}
                          </form>
                        ) : (
                          <p className="text-center text-muted">ไม่มีเอกสารที่ต้องอัปโหลด</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </Tab>

          <Tab eventKey="zoom" title="🎥 วีดีโอ ZOOM">
            <div className="container mt-3">
              {loadingZoom ? (
                <div className="text-center">
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden"></span>
                  </Spinner>
                  <p>กำลังโหลดวิดีโอ...</p>
                </div>
              ) : zoomVideos.length > 0 ? (
                <Table striped bordered hover responsive>
                  <thead>
                    <tr className="text-center">
                      <th>#</th>
                      <th>วันเวลา</th>
                      <th>วิดีโอ</th>
                      <th>ชนิดVDO</th>
                    </tr>
                  </thead>
                  <tbody>
                    {zoomVideos.map((video, index) => (
                      <tr key={video.id || index} className="text-center align-middle">
                        <td>{index + 1}</td>
                        <td>{formatDateTime(video.zoom_date_time)}</td>
                        <td>
                          <div className="d-flex justify-content-center">
                            <Button
                              variant="primary"
                              href={video.zoom_play_url}
                              target="_blank"
                              className="me-2"
                              size="sm"
                            >
                              ▶️ ดู
                            </Button>
                          </div>
                        </td>
                        <td>{(video.zoom_vdo_type)}</td>

                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                <p className="text-center text-muted">ไม่พบวิดีโอ ZOOM</p>
              )}
            </div>
          </Tab>
        </Tabs>
        {isAdmin === true && (
          <div className='col-12 m-2' style={{ textAlign: 'right' }}>

            <Button
              variant="warning"
              onClick={handleUpdateShopData}
            >
              ✏️ แก้ไข (Edit)
            </Button>
          </div>
        )}
        {isAdmin === true && (
          <div className='col-12 m-2' style={{ textAlign: 'right' }}>
            <Button variant="success" onClick={() => handleUpdateStatus("approve")} disabled={loading}>
              {loading ? "⏳ กำลังอนุมัติ..." : "✅ อนุมัติ (Approve)"}
            </Button>
            <Button variant="danger" onClick={() => handleUpdateStatus("reject")} disabled={loading}>
              {loading ? "⏳ กำลังยกเลิก..." : "❌ ยกเลิก (Reject)"}
            </Button>
          </div>
        )}
      </div>
      <div className="col-12 col-md-3">
        <ShopChat
          isPublic={false}
          onOpenUpload={{}}
          panel={panel}
          messages={chat}
          onAgree={onAgree}
          onReject={() => { }}
          onEdit={() => { }}
          onCancel={() => { }}
          onSendMessage={onSendMessage}
        />

      </div>
    </div>
  );
};

export default ModalItemshopAccountant;

